import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {MapsCommonService} from "../../../map/services/mapsCommon.service";

export class AddressResolverMapCtrl implements IController {
  originalAddress: any;
  validatedAddress: any;
  canEdit: boolean
  onValidatedAddressChange: Function;

  public validatedAddressEvents: any;

  private DEFAULT_MAP_ZOOM: any;
  private mapTypeIds: any;
  private filters: any;
  private map: any;
  private loading: boolean;
  private originalAddressOptions: any;
  private validatedAddressOptions: any;


  /* @ngInject */
  constructor(private $timeout: ITimeoutService, private mapsCommonService: MapsCommonService) {
  }

  $onInit() {

    this.originalAddressOptions = this.mapsCommonService.originalAddressOptions();
    this.validatedAddressOptions = this.mapsCommonService.validatedAddressOptions();

    this.DEFAULT_MAP_ZOOM = 14
    this.mapTypeIds = {
      roadmap: 'ROADMAP',
      satellite: 'SATELLITE'
    };

    this.filters = {
      traffic: false
    };

    this.map = {
      isReady: false,
      center: this._getMapCenter(),
      zoom: this.DEFAULT_MAP_ZOOM,
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false
      },
      events: {
        click: (map, eventType, event) => {

          if (this.validatedAddress && this.canEdit) {
            const lat = event[0].latLng.lat();
            const lng = event[0].latLng.lng();

            this.$timeout(() => {
              _.set(this.validatedAddress, 'location.latitude', lat);
              _.set(this.validatedAddress, 'location.longitude', lng);
              _.set(this.validatedAddress, 'location.lat', lat);
              _.set(this.validatedAddress, 'location.lng', lng);
              this.onValidatedAddressChange({address: this.validatedAddress});

            }, 0);
          }
        }
      }
    };

    this.validatedAddressEvents = {
      dragend: (marker, eventName, model) => {
        if (this.canEdit) {
          var lat = marker.position.lat(),
            lng = marker.position.lng();

          this.onValidatedAddressChange({address: this.validatedAddress});
        }
      }
    }


  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.originalAddress && !changes.originalAddress.isFirstChange()) {
      this.centerMap();
    }

    if (changes.canEdit && !changes.canEdit.isFirstChange()) {
      this.validatedAddressOptions.draggable = this.canEdit;
    }

  }


  onMapTypeChange(isSatelliteEnabled: any) {
    // this.map.options.mapTypeId = isSatelliteEnabled ? 'satellite' : 'roadmap';
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic = false;
    }
  }


  onAddressAutocompleteChange(address) {
    if (address && address.placeId) {

      _.set(this.validatedAddress, 'location.latitude', address.location.latitude);
      _.set(this.validatedAddress, 'location.longitude', address.location.longitude);
      _.set(this.validatedAddress, 'location.lat', address.location.latitude);
      _.set(this.validatedAddress, 'location.lng', address.location.longitude);

      this.map.center = address.location;
      this.map.zoom = this.DEFAULT_MAP_ZOOM;
      this.onValidatedAddressChange({address: this.validatedAddress});
    }
  }

  centerMap() {
    this.map.center = this._getMapCenter();
    this.map.zoom = this.DEFAULT_MAP_ZOOM;
  }

  _getMapCenter() {
    const lat = _.get(this.originalAddress, 'location.latitude');
    const lng = _.get(this.originalAddress, 'location.longitude');

    return lat && lng ?
      {latitude: lat, longitude: lng} :
      this.mapsCommonService.getSiteLocation();
  }

}

angular
  .module('bringoz.admin.addresses')
  .component('addressResolverMap', {
    bindings: {
      originalAddress: '<',
      validatedAddress: '<?',
      canEdit: '<',
      onValidatedAddressChange: '&'
    },
    template: require('./address-resolver-map.html').default,
    controller: AddressResolverMapCtrl
  });
